import React from 'react';
import steps from '../../survey/steps';
import SmartProgressBar from '../smartProgressBar';
import s from './index.module.scss';
import { useAppStore, useQuestionsStore } from '../../store';
import getParameterFromURL from '../../utils/scripts/getParameterFromURL';
import logoAvif from './img/logo.avif';
import logoPng from './img/logo.png';
import logoDarkAvif from './img/logoDark.avif';
import logoDarkPng from './img/logoDark.png';
import logoVetAvif from './img/logo-vet.avif';
import logoVetPng from './img/logo-vet.png';

type ClassValue = string | false | null | undefined;

const cx = (...args: ClassValue[]): string => args.filter(Boolean).join(' ');

const HEADER_VARIANTS = {
  noBorder: new Set(['start_page_age', 'start_page_age_v2', 'training_time', 'start_page_age_v3']),
};

const BASE_STEPS_WITHOUT_BACK = new Set([
  'customV2_creating_program', 'customV2_email', 'customV2_plan', 'customV3_gender',
  'customV2_age_v3', 'customV4_behavior_problem', 'customV5_behavior_problem',
  'customV2_age_v2', 'receive_email', 'gender_zw', 'customV2_age_v4', 'customV2_age_v5',
  'start_page_age', 'customV2_specialOffer_v2', 'start_page_age_v2', 'training_time',
  'customV2_specialOffer_v3', 'start_page_age_v3', 'customV2_specialOffer_v4',
]);

function SmartHeader(): React.ReactElement | null {
  const currentStep = useAppStore((state) => state.currentStep);
  const currentStepIndex = useAppStore((state) => state.currentStepIndex);
  const vetOnboarding = useAppStore((state) => state.vetOnboarding);
  const hideHeaderStepIndexes = useAppStore((state) => state.hideHeaderStepIndexes);
  const hideProgressStepIndexes = useAppStore((state) => state.hideProgressStepIndexes);
  const hideProgress = currentStepIndex !== null && hideProgressStepIndexes?.includes(currentStepIndex);
  const questions = useQuestionsStore((state) => state.list);

  if (
    currentStepIndex === null
    || hideHeaderStepIndexes?.includes(currentStepIndex)
  ) {
    return null;
  }

  const stepName = currentStep ?? '';
  const removeBackButton = BASE_STEPS_WITHOUT_BACK.has(stepName);

  const headerClassName = cx(
    s.header,
    HEADER_VARIANTS.noBorder.has(stepName) && s.header_noBorder,
  );

  const darkTheme = getParameterFromURL('darkTheme') === 'true';
  let logoSrcAvif = logoAvif;
  let logoSrcPng = logoPng;
  if (vetOnboarding) {
    logoSrcAvif = logoVetAvif;
    logoSrcPng = logoVetPng;
  } else if (darkTheme) {
    logoSrcAvif = logoDarkAvif;
    logoSrcPng = logoDarkPng;
  }

  function goBack(): void {
    try {
      const isTrainingTime = stepName === 'customV2_training_time';

      if (isTrainingTime) {
        const reasonAnswers = Object.values(questions?.customV2_reason?.answers || {});
        const dateAnswers = Object.values(questions?.customV2_date?.answers || {});
        const reasonIndex = reasonAnswers[0]?.index;

        if (reasonAnswers.length === 0 || reasonIndex === 'v8') {
          steps.navigate.back({ numberOfSteps: 3 });
        } else if (dateAnswers.length === 0) {
          steps.navigate.back({ numberOfSteps: 2 });
        } else {
          steps.navigate.back();
        }
      } else {
        steps.navigate.back();
      }

      steps.userMovedToPreviousStepByClick();
    } catch (error) {
      console.error('Error goBack:', error);
    }
  }

  return (
    <div className={s.headerWrapper}>
      <div className={headerClassName}>
        {!removeBackButton && (
          <button
            type="button"
            className={s.backButton}
            onClick={goBack}
            aria-label="Назад"
          />
        )}
        <picture>
          <source srcSet={logoSrcAvif} type="image/avif" />
          <img className={cx(s.logo, vetOnboarding && s.logoVet)} src={logoSrcPng} alt="logo" />
        </picture>
      </div>
      {!hideProgress && <SmartProgressBar />}
    </div>
  );
}

export default SmartHeader;
